import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { MultiSelect } from 'primereact/multiselect';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getCurrentCompany, getStyle, SERVICE_FLEET, SERVICE_WORKSHOP, styleMerge, TYPE_CARE_SERVICE, TYPE_WORKSHOP_ALL } from '../../../utils/utils';
import {
  fetchPredictedMaintenances as _fetchPredictedMaintenances,
} from '../../../actions/predictedMaintenanceActions';
import {
  fetchVehiclesByOrganization as _fetchVehiclesByOrganization,
  fetchVehiclesForCareService as _fetchVehiclesForCareService
} from '../../../actions/vehicleActions';
import CBPromptModal from '../../shared/CBPromptModal';
import PredictedMaintenanceListItem from './PredictedMaintenanceListItem';
import VehicleListTh from '../../OrganizationGarageView/OrganizationGarageComponents/VehicleListTh';
import PredictedMaintenanceFilterBar from './PredictedMaintenanceFilterBar';
import CBLabelAndCheckbox from '../../shared/CBLabelAndCheckbox';
import VehicleActionBar from '../../shared/VehicleActionBar';
import AddMessageModal from '../../VehicleDetailsView/VehicleDetailsComponents/AddMessageModal';
import moment from 'moment';
import { companySwitchState, listStateKey, loadListState, saveListState } from '../../../utils/listState';

class PredictedMaintenancesListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      messageModalIsOpen: false,
      search: '',
      ordering: 'due_at',
      filters: {
          due_at__lte: moment().add(45, 'days').format('YYYY-MM-DD'),
      },
      fields: [],
      selectedFields: [],
      selectedPredictedMaintenances: [],
      page: 1,
    };
    this.tableScrollRef = React.createRef();
    this.topScrollRef = React.createRef();
    this._isSyncingScroll = false;
  }

  componentDidMount() {
    this.syncTopScrollWidth();
    if (typeof ResizeObserver !== 'undefined' && this.tableScrollRef.current) {
      this._resizeObserver = new ResizeObserver(this.syncTopScrollWidth);
      this._resizeObserver.observe(this.tableScrollRef.current);
    }
  }

  componentWillUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  syncTopScrollWidth = () => {
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      var inner = this.topScrollRef.current.firstChild;
      if (inner) {
        inner.style.width = this.tableScrollRef.current.scrollWidth + 'px';
      }
    }
  };

  handleTopScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      this.tableScrollRef.current.scrollLeft = this.topScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  handleTableScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.topScrollRef.current && this.tableScrollRef.current) {
      this.topScrollRef.current.scrollLeft = this.tableScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  componentWillMount() {
    const {
      t,
      fetchPredictedMaintenances,
      fetchVehiclesByOrganization,
      fetchVehiclesForCareService,
      service,
      selectedWorkshopId,
      selectedOrganizationId,
    } = this.props;

    // Fetch vehicles for the message modal
    if (service === SERVICE_WORKSHOP) {
      fetchVehiclesForCareService(selectedWorkshopId, {ordering: 'registration_number'});
    } else if (service === SERVICE_FLEET) {
      fetchVehiclesByOrganization(selectedOrganizationId, { ordering: 'registration_number' });
    }

    const selectedFields = JSON.parse(localStorage.getItem('selectedPredictedMaintenanceFields'));

    const allFields = [
      {
        label: t('headingRegistrationNumber'),
        value: 'vehicle_registration_number',
      },
      {
        label: t('headingCompanyAndGarage'),
        value: 'organization',
      },
      {
        label: t('headingDueAt'),
        value: 'due_at',
      },
      {
        label: t('nextPredictedMaintenanceType', {ns: 'VehicleDetailsView'}),
        value: 'prediction_type',
      },
    ];

    if (this.getCurrentCompany().use_vehicle_identifier) {
      allFields.splice(1, 0, {
        label: t('headingVehicleIdentifier'),
        value: 'vehicle_identifier',
      })
    }

    this.setState({
      fields: allFields,
    });

    this.setState({
      selectedFields: selectedFields || this.getDefaultFields(),
    });

    // Load saved list state per company before initial fetch
    const savedState = this.loadListStateFromStorage();
    if (savedState) {
      const { search, ordering: savedOrdering, filters, page } = savedState;
      this.setState({
        search: search || '',
        ordering: savedOrdering || this.state.ordering,
        filters: filters || this.state.filters,
        page: page || 1,
      }, () => {
        this.refetchPredictedMaintenances(savedOrdering || this.state.ordering, filters || this.state.filters, page || this.state.page, true);
      });
    } else {
      this.refetchPredictedMaintenances(null, null);
    }
  }

  getDefaultFields = () => {
    let defaultFields =  [
      'vehicle_registration_number',
      'status',
      'organization',
      'employee',
      'origin',
      'due_at',
      'prediction_type'
    ];

    if (this.getCurrentCompany().use_vehicle_identifier) {
      defaultFields.push('vehicle_identifier');
    }

    return defaultFields;
  }

  getCurrentCompany = () => {
    const {
      user,
      selectedOrganizationId,
      selectedWorkshopId,
      selectedChainId
    } = this.props;

    return getCurrentCompany(user, selectedOrganizationId, selectedWorkshopId, selectedChainId) || {};
  }

  setSelectedFields = (newSelectedFields) => {
    this.setState({
      selectedFields: newSelectedFields,
    });
    JSON.stringify(newSelectedFields);
    localStorage.setItem('selectedPredictedMaintenanceFields', JSON.stringify(newSelectedFields));
  }

  getCompanyScopeKey = () => {
    const { service, selectedWorkshopId, selectedOrganizationId } = this.props;
    if (service === SERVICE_WORKSHOP) {
      return listStateKey('predictedMaintenanceListState', 'workshop', selectedWorkshopId);
    }
    if (service === SERVICE_FLEET) {
      return listStateKey('predictedMaintenanceListState', 'organization', selectedOrganizationId);
    }
    return listStateKey('predictedMaintenanceListState', 'unknown', null);
  }

  saveListStateToStorage = () => {
    const { search, ordering, filters, page } = this.state;
    saveListState(this.getCompanyScopeKey(), { search, ordering, filters, page });
  }

  loadListStateFromStorage = () => loadListState(this.getCompanyScopeKey())

  getGarage = () => {
    const { garages, garageId } = this.props;
    return garages.find(garage => garage.id == garageId);
  }

  getSelectedPredictedMaintenances = () => {
    const { selectedPredictedMaintenances } = this.state;
    const { predictedMaintenances } = this.props;

    return predictedMaintenances.filter((msg) => selectedPredictedMaintenances.includes(msg.id));
  };

  selectVehicle = (predictedMaintenanceId) => {
    const { selectedPredictedMaintenances } = this.state;

    const newSelectedPredictedMaintenances = selectedPredictedMaintenances.slice();

    newSelectedPredictedMaintenances.push(predictedMaintenanceId);
    this.setState({ selectedPredictedMaintenances: newSelectedPredictedMaintenances });
  };

  unselectVehicle = (predictedMaintenanceId) => {
    const { selectedPredictedMaintenances } = this.state;

    const newSelectedPredictedMaintenances = selectedPredictedMaintenances.filter((item) => item !== predictedMaintenanceId);

    this.setState({ selectedPredictedMaintenances: newSelectedPredictedMaintenances });
  };

  changeSearchTerms = value => {
    this.setState({
      search: value,
    }, () => {
      this.saveListStateToStorage();
    });
  }

  changeFilterTerms = value => {
    this.setState({
      filters: value,
      page: 1, // Reset to page 1 when filters change
    }, () => {
      this.saveListStateToStorage();
      this.refetchPredictedMaintenances(null, value, 1);
    });
  }

  refetchPredictedMaintenances = (newOrdering = null, newFilters = null, newPage = null, isRestored = false) => {
    const { fetchPredictedMaintenances, garageId, service, selectedWorkshopId, selectedOrganizationId } = this.props;
    const { search, ordering, filters, page } = this.state;

    const params = {
      search,
      ordering: newOrdering || ordering,
      garage_id: garageId
    };

    // Only force page 1 if we're not restoring saved state and there are actual changes
    if (!isRestored && (newFilters || newOrdering)) {
      params.page = 1;
    } else {
      params.page = newPage || page;
    }

    fetchPredictedMaintenances(
      newFilters ? { ...newFilters, ...params } : { ...filters, ...params },
      service === SERVICE_WORKSHOP && selectedWorkshopId,
      service === SERVICE_FLEET && selectedOrganizationId,
    );

    this.saveListStateToStorage();
  };

  changeOrdering = (clickedOrdering) => {
    const { ordering } = this.state;
    let newOrdering;
    if (ordering === clickedOrdering) {
      newOrdering = `-${ordering}`;
    } else if (`-${ordering}` === clickedOrdering) {
      newOrdering = 'id';
    } else {
      newOrdering = clickedOrdering;
    }
    this.setState({
      ordering: newOrdering,
      page: 1, // Reset to page 1 when ordering changes
    }, () => {
      this.saveListStateToStorage();
      this.refetchPredictedMaintenances(newOrdering, null, 1);
    });
  };

  getOrderingSymbol = (columnName) => {
    const { ordering } = this.state;
    if (ordering === columnName) {
      return '/img/down_arrow_icon.svg';
    } else if (ordering === `-${columnName}`) {
      return '/img/up_arrow_icon.svg';
    }
    return undefined;
  };

  selectAllPredictedMaintenances = () => {
    const { predictedMaintenances } = this.props;

    const newSelectedPredictedMaintenances = predictedMaintenances.map((predictedMaintenance) => predictedMaintenance.id);
    this.setState({ selectedPredictedMaintenances: newSelectedPredictedMaintenances });
  };

  unselectAllPredictedMaintenances = () => {
    this.setState({ selectedPredictedMaintenances: [] });
  };

  selectAllChanged = () => {
    const { predictedMaintenances } = this.props;
    const { selectedPredictedMaintenances } = this.state;
    const allChecked = selectedPredictedMaintenances.length === predictedMaintenances.length;

    if (allChecked) {
      this.unselectAllPredictedMaintenances();
    } else {
      this.selectAllPredictedMaintenances();
    }
  }

  sendMessages = () => {
    this.setState({
      messageModalIsOpen: true,
    });
  };

  closeMessageModal = () => {
    this.setState({
      messageModalIsOpen: false,
    });
  };

  getSelectedVehicleIds = () => {
    const { selectedPredictedMaintenances } = this.state;
    const { predictedMaintenances } = this.props;

    // Extract vehicle IDs from selected predicted maintenances
    const selectedItems = predictedMaintenances.filter((pm) => selectedPredictedMaintenances.includes(pm.id));
    return selectedItems.map((pm) => pm.vehicle);
  };

  getSelectedVehicles = () => {
    const { selectedPredictedMaintenances } = this.state;
    const { predictedMaintenances, careServiceVehicles, garageVehicles, service } = this.props;

    // Get vehicle IDs from selected predicted maintenances
    const selectedItems = predictedMaintenances.filter((pm) => selectedPredictedMaintenances.includes(pm.id));
    const selectedVehicleIds = selectedItems.map((pm) => pm.vehicle);

    // Get full vehicle objects from the vehicles list
    const vehicles = service === SERVICE_WORKSHOP ? careServiceVehicles : garageVehicles;
    return vehicles.filter((v) => selectedVehicleIds.includes(v.id));
  };

  componentDidUpdate(prevProps) {
    this.syncTopScrollWidth();
    const { selectedWorkshopId, selectedOrganizationId, service } = this.props;

    if (selectedWorkshopId != prevProps.selectedWorkshopId
      || selectedOrganizationId != prevProps.selectedOrganizationId
      || service != prevProps.service) {
      // A company with no saved state of its own starts clean: keeping the
      // previous company's search and filters would both show the wrong list
      // and — since the refetch persists what it sent — write them into the new
      // company's entry (see utils/listState).
      const savedState = this.loadListStateFromStorage();
      const nextState = companySwitchState(savedState, this.state.ordering);
      this.setState(nextState, () => {
        this.refetchPredictedMaintenances(nextState.ordering, nextState.filters, nextState.page, !!savedState);
      });
    }
  }

  render() {
    const {
      predictedMaintenances,
      t,
      removeVehicleFromGarage,
      user,
      service,
      selectedWorkshopId,
      careServiceVehicles,
      garageVehicles
    } = this.props;

    const {
      selectedPredictedMaintenances,
      filters,
      messageModalIsOpen
    } = this.state;

    const { fields, selectedFields } = this.state;
    const garage = this.getGarage();

    const vehicles = service === SERVICE_WORKSHOP ? careServiceVehicles : garageVehicles;
    const selectedVehicleIds = this.getSelectedVehicleIds();
    // For workshops, always enable messages. For fleet, check the feature flag
    const hasFeatureTasksAndMessages = service === SERVICE_WORKSHOP
      ? true
      : (user && user.organizations && user.organizations.length > 0
          ? user.organizations[0].feature_tasks_and_messages_enabled
          : false);

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'topBarsContainer')}>
              <PredictedMaintenanceFilterBar
                useIdentifiers={this.getCurrentCompany().use_vehicle_identifier}
                changeSearchTerms={this.changeSearchTerms}
                changeFilterTerms={this.changeFilterTerms}
                refetchPredictedMaintenances={this.refetchPredictedMaintenances}
                filters={filters}
                search={this.state.search}
              />
              <hr style={{ opacity: '30%' }} />
              <VehicleActionBar
                selectedVehicles={selectedVehicleIds}
                sendMessages={this.sendMessages}
                updateVehicles={() => {}}
                hasFeatureTasksAndMessages={hasFeatureTasksAndMessages}
                hideUpdateButton={true}
              />
            </div>

            <div
              ref={this.topScrollRef}
              onScroll={this.handleTopScroll}
              style={getStyle(screenSize, styles, 'topScrollbar')}
              className="vehicle-table-scrollbar"
            >
              <div style={getStyle(screenSize, styles, 'topScrollbarInner')} />
            </div>
            <div
              ref={this.tableScrollRef}
              onScroll={this.handleTableScroll}
              style={getStyle(screenSize, styles, 'tableContainer')}
              className="vehicle-table-scrollbar"
            >
              <table style={getStyle(screenSize, styles, 'table')}>
                <thead>
                  <tr>
                    <th style={styleMerge(getStyle(screenSize, styles, 'tableHeaderFirst'), getStyle(screenSize, styles, 'alignCenter'))}>
                      <CBLabelAndCheckbox
                        checked={selectedPredictedMaintenances.length === predictedMaintenances.length}
                        additionalStyles={{ justifyContent: 'center' }}
                        onChange={this.selectAllChanged}
                      />
                    </th>

                    {
                      selectedFields.includes('vehicle_identifier') && this.getCurrentCompany().use_vehicle_identifier && (
                        <VehicleListTh
                          text={t('headingVehicleIdentifier')}
                          fieldName='vehicle_identifier'
                          orderingSymbol={this.getOrderingSymbol('vehicle_identifier')}
                          changeOrdering={() => {
                            this.changeOrdering('vehicle_identifier');
                          }}
                        />
                      )
                    }

                    <VehicleListTh
                      text={t('headingRegistrationNumber')}
                      fieldName='vehicle_registration_number'
                      orderingSymbol={this.getOrderingSymbol('vehicle_registration_number')}
                      changeOrdering={() => {
                        this.changeOrdering('vehicle_registration_number');
                      }}
                    />

                    {
                      selectedFields.includes('organization') && (
                        <VehicleListTh
                          text={t('headingCompanyAndGarage')}
                          fieldName='organization'
                          orderingSymbol={this.getOrderingSymbol('organization__name')}
                          changeOrdering={() => {
                            this.changeOrdering('organization__name');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('due_at') && (
                        <VehicleListTh
                          text={t('headingDueAt')}
                          fieldName='due_at'
                          orderingSymbol={this.getOrderingSymbol('due_at')}
                          changeOrdering={() => {
                            this.changeOrdering('due_at');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('prediction_type') && (
                        <VehicleListTh
                          text={t('nextPredictedMaintenanceType', { ns: 'VehicleDetailsView'})}
                          fieldName='prediction_type'
                          orderingSymbol={this.getOrderingSymbol('prediction_type')}
                          changeOrdering={() => {
                            this.changeOrdering('prediction_type');
                          }}
                        />
                      )
                    }

                    <th></th>


                    <th style={getStyle(screenSize, styles, 'tableHeaderSettings')}>
                      <MultiSelect
                        value={selectedFields}
                        onChange={(e) => this.setSelectedFields(e.value)}
                        options={fields}
                        className="bars"
                        dropdownIcon={undefined}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {predictedMaintenances.map(predictedMaintenance => (
                    <PredictedMaintenanceListItem
                      selectedFields={selectedFields}
                      predictedMaintenance={predictedMaintenance}
                      key={predictedMaintenance.id}
                      garage={garage}
                      selected={selectedPredictedMaintenances.includes(predictedMaintenance.id)}
                      removeVehicleFromGarage={removeVehicleFromGarage}
                      select={this.selectVehicle}
                      unselect={this.unselectVehicle}
                      service={service}
                      selectedWorkshopId={selectedWorkshopId}
                      useVehicleIdentifier={this.getCurrentCompany().use_vehicle_identifier}
                    />
                  ))}
                </tbody>
              </table>
            </div>

            {
              messageModalIsOpen && (
                <AddMessageModal
                  modalIsOpen={messageModalIsOpen}
                  closeModal={this.closeMessageModal}
                  afterOpenModal={() => {}}
                  selectedVehicles={this.getSelectedVehicles()}
                  vehicles={vehicles}
                  afterSubmit={() => {
                    this.setState({ selectedPredictedMaintenances: [] });
                    this.closeMessageModal();
                  }}
                />
              )
            }
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      width: '100%',
      padding: '0px 16px 0px 0px',
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 20,
    },
    searchContainer: {
      maxWidth: 600,
    },
    tableContainer: {
      width: '100%',
      overflowX: 'auto',
      marginBottom: '24px',
      paddingBottom: 16,
      position: 'relative',
    },
    table: {
      whiteSpace: 'nowrap',
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    topScrollbar: {
      overflowX: 'auto',
      overflowY: 'hidden',
      width: '100%',
      marginTop: 12,
    },
    topScrollbarInner: {
      height: 1,
    },
    tableHeader: {
      fontFamily: 'TitilliumWeb-Bold',
      color: '#FFFFFF',
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      padding: '8px 8px 8px 8px',
    },
    tableHeaderSettings: {
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      //position: 'sticky',
      padding: '8px 8px 8px 8px',
      right: 0,
    },
    tableHeaderFirst: {
      //position: 'sticky',
      left: 0,
    },
    alignCenter: {
      textAlign: 'center',
    },
    topBarsContainer: {
      paddingLeft: 16,
    },
  },
  medium: {
    table: {
    },
  },
  small: {
    table: {
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    garages: state.garage.garages,
    service: state.app.service,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedOrganizationId: state.organization.selectedOrganization,
    selectedChainId: state.chain.selectedChainId,
    careServiceVehicles: state.vehicle.careServiceVehicles,
    garageVehicles: state.vehicle.garageVehicles,
    predictedMaintenances: state.predictedMaintenance.predictedMaintenances,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchPredictedMaintenances: _fetchPredictedMaintenances,
    fetchVehiclesByOrganization: _fetchVehiclesByOrganization,
    fetchVehiclesForCareService: _fetchVehiclesForCareService,
  },
)(translate('PredictedMaintenancesListView')(PredictedMaintenancesListView));
